import { render } from "./FormRelManyDescrTypes.vue?vue&type=template&id=2029f5cc"
import script from "./FormRelManyDescrTypes.vue?vue&type=script&lang=js"
export * from "./FormRelManyDescrTypes.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/DataForm/FormRelManyDescrTypes.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2029f5cc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2029f5cc', __exports__)) {
    console.log('reload')
    api.reload('2029f5cc', __exports__)
  }
  
  module.hot.accept("./FormRelManyDescrTypes.vue?vue&type=template&id=2029f5cc", () => {
    console.log('re-render')
    api.rerender('2029f5cc', render)
  })

}


export default __exports__